// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-apply__travel-row .name {\n  display: inline-block;\n  width: 140px;\n}\n", ""]);
// Exports
module.exports = exports;
